export const tabs = [
    {
      name: "Outreaches",
      tabCount: "OutreachesTotalCount",
      key: "1",
    },
    // {
    //   name: "All Entries",
    //   tabCount: "allOutreachesTotalCount",
    //   key: "2",
    // },
  ];

export const cadenceTabs = [
  {
    name: "Cadence",
    tabCount: "CadenceTotalCount",
    key: "2",
  }
]

export const TIMELINE = 'timeline';

export const CARD = 'card';